import React from "react";
import { IconsProps } from "./dto";

export function PhoneIcon(props: IconsProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.99984 15.0001H10.0082M5.83317 1.66675H14.1665C15.087 1.66675 15.8332 2.41294 15.8332 3.33341V16.6667C15.8332 17.5872 15.087 18.3334 14.1665 18.3334H5.83317C4.9127 18.3334 4.1665 17.5872 4.1665 16.6667V3.33341C4.1665 2.41294 4.9127 1.66675 5.83317 1.66675Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}